export default class UserService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('users', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('users/' + id, params)
	}

	getLoggedUserData() {
		return this.apiService.callGet('users/loggedUser')
	}

	createEntity(params) {
		return this.apiService.callPost('users', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('users/' + id, params)
	}

	uploadEntityImage(id, file) {
		return this.apiService.callPost('users/' + id + '/user_image', file)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('users/' + id, params)
	}

	deleteImage(id) {
		return this.apiService.callDelete('users/' + id + '/image')
	}

  resetUserPassword(id, params){
    return this.apiService.callPost('me/users/'+ id + '/reset_password', params);
  }
}



// WEBPACK FOOTER //
// ./src/service/UserService.js